import clsx from 'clsx'
import React, { useCallback, useState } from 'react'

import { Button } from '@Components/Button'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'
import { EmailValidationV2 } from '@Shared/Components/Forms/Validations/EmailValidation'
import { NotEmptyValidationV2 } from '@Shared/Components/Forms/Validations/NotEmptyValidation'
import { TextInput, useTextInputActionRef } from '@Shared/Components/Inputs/TextInput/TextInput'

import styles from './styles.module.scss'

export const ClubEmailDecision = () => {
  const { check, defaultEmail, setDefaultEmail, setModalState } = useClub()
  const { t } = useTranslation()
  const [email, setEmail] = useState(defaultEmail || '')
  const emailActionRef = useTextInputActionRef()

  const onEmailEntered = useCallback(async () => {
    const result = await check({ email })
    if (!result) {
      console.error('oh no my friend, something unexpected happened')
      return
    }

    setDefaultEmail(email)

    setModalState((prev) => {
      if (prev !== 'EMAIL_DECISION') {
        return prev
      }

      return result.nextModalState
    })
  }, [email, setDefaultEmail, setModalState, check])

  return (
    <form onSubmit={(e) => {
      e.preventDefault()
      e.stopPropagation()
      emailActionRef.current?.touch()
      const isEmailValid = emailActionRef.current?.validate()
      if (isEmailValid) {
        onEmailEntered()
      }
    }}
    >
      <p className={clsx(styles.formElementGab, styles.bigLabel)}>{t('common:TRENDHIMCLUB_LOGIN_TITLE')}</p>
      <label className={clsx(styles.formElementGab, styles.smallLabel)} htmlFor="ClubModal_EMAIL">{t('common:TRENDHIMCLUB_ENTER_YOUR_EMAIL')}</label>
      <TextInput
        actionRef={emailActionRef}
        autoFocus
        id="ClubModal_EMAIL"
        label={t('common:EMAIL_ADDRESS')}
        onChange={value => setEmail(value)}
        validations={[EmailValidationV2, NotEmptyValidationV2]}
        value={email}
      />
      <Button className={styles.nextButton} color="black" type="submit">{t('common:NEXT_LABEL')}</Button>
    </form>
  )
}

